export const SAVE_DIALOG_AUTO_CLOSE_TIMEOUT = 2000;
